/// <amd-module name="VSSUI/Components/ComboBox/index" />

export * from "./ComboBox";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export { IComboBoxProps, IComboBoxOption } from "./ComboBox.Props";
